import { DashboardActions, EDashboardActions } from '../actions/dashboard.actions';
import { DashboardDataState, initialDashboardDataState } from '../states/dashboard-data.state';
import { initialRegionDataState, RegionDataState } from '../states/region-data.state';

export function dashboardReducers(
    state = initialDashboardDataState,
    action: DashboardActions
): DashboardDataState {
    switch (action.type) {
        case EDashboardActions.GetChartsDataSuccess: {
            return {
                ...state,
                dashboardData: action.payload
            };
        }
        case EDashboardActions.GetChartsDataFailure: {
            return {
                ...state,
                dashboardData: null
            };
        }

        default:
            return state;
    }
}

export function regionDataReducers(
    state = initialRegionDataState,
    action: DashboardActions
): RegionDataState {
    switch (action.type) {
        case EDashboardActions.GetRegionDataSuccess: {
            return {
                ...state,
                regionData: action.payload
            };
        }
        case EDashboardActions.GetRegionDataFailure: {
            return {
                ...state,
                regionData: null
            };
        }

        default:
            return state;
    }
}
